import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_service_categories`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_service_categories/${id}`, options)
    .then(response => {
      let service_categories = jsona.deserialize(response.data);
      delete service_categories.links;
      return service_categories;
    });
}

function add(service_categories) {
  
  console.log(service_categories);
  const payload = jsona.serialize({
    stuff: service_categories,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
    
  };

  return axios.post(`${url}/workshop/workshop_service_categories`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(service_categories) {
  const payload = jsona.serialize({
    stuff: service_categories,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_service_categories/${service_categories.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_service_categories/${id}`, options);
}




export default {
  list,
  get,
  add,
  update,
  destroy,
};

